<template>
    <div class="row g-4">
        <div class="col-12">
            <h2 id="panelnameheader">{{ short }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">
                    <a href="javascript:void(0);"><strong>{{ short }}</strong></a>
                </li>
                <li class="breadcrumb-item" v-for="n in utrange" :key="n">
                    <router-link :to="'/clients/' + n + '/0'">{{ gettypeshort(n) }}</router-link>
                </li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive">
                <DataTable v-model:filters="filters" :value="userswithfilter" paginator showGridlines :rows="200"
                    dataKey="N" filterDisplay="menu" :globalFilterFields="['N']" removableSort scrollable
                    :rowsPerPageOptions="[200, 500, 1000]"
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}" size="small"
                    paginatorPosition="bottom" tableStyle="min-width: 50rem">
                    <template #header>
                        <div class="row row5">
                            <div class="col-md-6 mb-2 search-form">
                                <form method="post" class="ajaxFormSubmit">
                                    <div
                                        class="d-inline-block form-group form-group-feedback form-group-feedback-right">
                                        <input type="text" name="searchKey" placeholder="Search User"
                                            class="form-control form-control-sm" v-model="search" />
                                    </div>
                                    <div class="d-inline-block">
                                        <!-- <button type="submit" id="submit" class="btn btn-primary">Load</button>  -->
                                        <button type="button" id="reset" class="btn btn-dark m-2"
                                            v-on:click="search = ''"><span>Reset</span></button>
                                    </div>
                                </form>
                            </div>
                            <div class="col-md-6 text-right mb-2">
                                <div class="d-inline-block mr-2">
                                    <div id="export_1700317536927" class="d-inline-block">
                                        <button type="button" class="btn mr-1 btn-success btn-sm"><i
                                                class="fas fa-file-excel"></i></button>
                                    </div>
                                    <button type="button" class="btn btn-danger btn-sm"><i
                                            class="fas fa-file-pdf"></i></button>
                                </div>
                                <div class="d-inline-block">
                                    <router-link to="/admin/users/insertuser" aria-current="page"
                                        class="btn btn-success m-2">
                                        CREATE {{ short }}</router-link>
                                </div>
                            </div>
                        </div>
                    </template>
                    <Column field="N" header="User Name" sortable>
                        <template #body="{ data }">
                            <!-- <pre>{{ data }}</pre> -->
                            <span v-if="data.Ut === 16 || data.Ut === 99" class="wrape-text" v-tooltip="data.Dn"
                                placeholder="Right">{{ data.N }}</span>
                            <router-link :to="'/clients/0/' + data.Id" v-if="data.Ut !== 16 && data.Ut !== 99"
                                class="wrape-text" v-tooltip="data.Dn" placeholder="Right">{{ data.N }}</router-link>
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText v-model="filterModel.value" type="text" class="p-column-filter"
                                placeholder="Search by User Name" />
                        </template>
                    </Column>
                    <Column field="C" header="CR" style="text-align: right" class="text-end"
                        headerStyle="{text-align: right !important;}" sortable>
                        <template #body="{ data }">
                            <span v-on:click="selectshowcredit(data)" v-if="data.Iuu === 1">{{ data.C.toLocaleString()
                            }}</span>
                            <span v-if="data.Iuu === 0">{{ data.C.toLocaleString() }}</span>
                        </template>
                    </Column>
                    <Column field="B" header="PTS" class="text-end" sortable>
                        <template #body="{ data }">
                            <!-- {{ data.Ut === 16 ? data.B.toLocaleString() : data.Df.toLocaleString(undefined, {minimumFractionDigits: 2}) }} -->
                            <span :class="{ 'text-danger': data.Df < 0, 'text-success': data.Df >= 0 }">{{
                                data.Df.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</span>
                        </template>
                    </Column>
                    <!-- <Column field="Dl" header="(D/L)" class="text-end" sortable>
                      <template #body="{ data }">
                        {{ data.Dl.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                      </template>
                    </Column>
                    <Column field="D" header="(P/L)" class="text-end" sortable>
                      <template #body="{ data }">
                        {{ data.D.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                      </template>
                    </Column> -->
                    <Column field="U" header="Client(P/L)" class="text-end" sortable>
                        <template #body="{ data }">
                            <!-- {{ data.Ut === 16 ? data.B.toLocaleString() : data.D.toLocaleString() }} -->
                            <span :class="{ 'text-danger': data.U < 0, 'text-success': data.U >= 0 }">{{
                                data.U.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</span>
                        </template>
                    </Column>
                    <Column field="L" header="Exposure" class="text-end text-danger" sortable>
                        <template #body="{ data }">
                            {{ data.L.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                        </template>
                    </Column>
                    <Column field="" header="Available" class="text-end" sortable>
                        <template #body="{ data }">
                            {{ data.Ut === 16 ? (data.C + data.U + data.L).toLocaleString() : (data.C + data.Df +
                                data.L).toLocaleString() }}
                        </template>
                    </Column>
                    <Column field="Ab" header="B St" class="text-center">
                        <template #body="{ data }">
                            <InputSwitch :modelValue="data.Ab" v-on:click="selectshowallowbet(data)"
                                v-if="data.Iuu === 1" />
                            <InputSwitch :modelValue="data.Ab" disabled v-if="data.Iuu === 0" />
                        </template>
                    </Column>
                    <Column field="A" header="U St" class="text-center">
                        <template #body="{ data }">
                            <InputSwitch :modelValue="data.A" v-if="data.Iuu === 1"
                                v-on:click="selectshowactive(data)" />
                            <InputSwitch :modelValue="data.A" disabled v-if="data.Iuu === 0" />
                        </template>
                    </Column>
                    <Column field="Asc" header="C St" class="text-center">
                        <template #body="{ data }">
                            <InputSwitch :modelValue="data.Asc" v-on:click="selectshowcasino(data)"
                                v-if="data.Iuu === 1" />
                            <InputSwitch :modelValue="data.Asc" disabled v-if="data.Iuu === 0" />
                        </template>
                    </Column>
                    <Column field="S" header="Pname" class="text-center">
                        <template #body="{ data }">
                            <span>{{ data.T !== 16 && data.S > 0 ? data.S.toLocaleString() + " PNR" : " 0 PNR" }}</span>
                        </template>
                    </Column>
                    <Column field="Ut" header="Account Type" class="text-center">
                        <template #body="{ data }">
                            <span>{{ gettype(data.Ut) }}</span>
                        </template>
                    </Column>
                    <Column field="" header="Action" class="text-center">
                        <template #body="{ data }">
                            <div role="group" class="btn-group">
                                <button type="button" class="btn btn-grd btn-grd-success btn-sm"
                                    v-on:click="selectshowpl(data, 1)"
                                    :disabled="data.Iuu !== 1 || data.U > 0 || data.U === 0">D</button>
                                <button type="button" class="btn btn-grd btn-grd-danger btn-sm"
                                    v-on:click="selectshowpl(data, 2)"
                                    :disabled="data.Iuu !== 1 || data.U < 0 || data.U === 0">W</button>
                                <button type="button" class="btn btn-grd btn-grd-info btn-sm"
                                    v-on:click="selectshowmore(data)">More</button>
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>
<script>
import $$vm from "@/data/index";
import RadioButton from "primevue/radiobutton";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import InputNumber from "primevue/inputnumber";
import { FilterMatchMode, FilterOperator } from "@primevue/core/api";
import Button from "primevue/button";
//   import { useToast } from "primevue/usetoast";
import Badge from "primevue/badge";

export default {
    name: "Clients",
    components: { DataTable, Column, InputText, InputSwitch, InputNumber, Button, Dialog, RadioButton, Badge },
    data() {
        return {
            id: "",
            id1: "",
            short: "",
            credittab: 1,
            toast: undefined,
            maximum: true,
            showcredit: false,
            showactive: false,
            showcasino: false,
            showallowbet: false,
            showmore: false,
            showmoretab: 1,
            selected: undefined,
            settlementamount: 0,
            settledadd: false,
            settlementname: "",
            settlementtc: "",
            settlementrc: false,
            settlementremark: "",
            cricdc: 0,
            socdc: 0,
            tendc: 0,
            hordc: 0,
            gredc: 0,
            id: undefined,
            first: false,
            users: [],
            users1: [],
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                N: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            search: "",
            maxcredit: 0,
            commissionsettings: {},
            headerpl: "",
            showpl: false,
            utrange: [],
        }
    },
    computed: {
        userswithfilter: function () {
            var self = this;
            if (self.search.length > 0) {
                var users1 = [];
                $.each(self.users, function (ii, jj) {
                    if (jj.N.toLowerCase().indexOf(self.search.toLowerCase()) !== -1 && (self.id === "0" || jj.Ut === parseInt(self.id))) {
                        users1.push(jj);
                    }
                });
                return users1;
            }
            else {
                var users1 = [];
                $.each(self.users, function (ii, jj) {
                    if (self.id === "0" || jj.Ut === parseInt(self.id)) {
                        users1.push(jj);
                    }
                });
                return users1;
                //return self.users;
            }
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.short = this.gettypeshort(this.id);
        this.id1 = this.$route.params.id1;
        this.id1 = this.id1 === undefined || this.id1 === null ? "" : (this.id1 === "0" ? "" : this.id1);
        // this.checkid();
        this.initFilters();
        this.update();
    },
    methods: {
        getusertyperange: function () {
            var res = $$vm.getusertyperange();
            var res1 = [];
            $.each(res, function (ii, jj) {
                if (jj !== parseInt(this.id)) {
                    res1.push(jj);
                }
            });
            return res1;
        },
        gettypeshort: function (n) {
            return $$vm.gettypeshort(n);
        },
        gettype: function (t) {
            return $$vm.gettype(t);
        },
        initFilters: function () {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                N: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        checkid: function () {
            var self = this;
            if ((self.$route.params.id !== undefined && self.id !== self.$route.params.id) || (self.$route.params.id === undefined && self.id.length > 0)) {
                self.id = self.$route.params.id;
                self.id = self.id === undefined || self.id === null ? "" : self.id;
                self.first = false;
                self.short = self.gettypeshort(self.id);
            }
            if ((self.$route.params.id1 !== undefined && self.id1 !== self.$route.params.id1) || (self.$route.params.id1 === undefined && self.id1.length > 0)) {
                self.id1 = self.$route.params.id1;
                self.id1 = self.id1 === undefined || self.id1 === null ? "" : (self.id1 === "0" ? "" : self.id1);
            }
            setTimeout(function () {
                self.checkid();
            }, 1000);
        },
        update: function (check) {
            if (check === undefined) {
                check = false;
            }
            var self = this;
            //console.log(self.$route.name + " " + check + " " + self.id + " " + self.id1);
            if (self.$route.name !== "Clients") {
                setTimeout(function () {
                    self.update();
                }, 1000);
                return;
            }
            if (self.$route.params !== undefined && self.$route.params !== null) {
                if (self.$route.params.id1 !== undefined && self.$route.params.id1 !== null) {
                    if (self.id1 !== self.$route.params.id1) {
                        self.id1 = self.$route.params.id1;
                        self.id1 = self.id1 === undefined || self.id1 === null ? "" : (self.id1 === "0" ? "" : self.id1);
                        check = true;
                        self.utrange = $$vm.getusertyperange();;
                    }
                }
                if (self.$route.params.id !== undefined && self.$route.params.id !== null) {
                    if (self.id !== self.$route.params.id) {
                        check = true;
                        self.id = self.$route.params.id;
                        self.short = self.gettypeshort(self.id);
                    }
                }
            }
            if (!self.first) {
                check = true;
                self.first = true;
                self.cricdc = $$vm.cricd.length;
                self.socdc = $$vm.socd.length;
                self.tendc = $$vm.tend.length;
                self.hordc = $$vm.hord.length;
                self.gredc = $$vm.gred.length;
            } else {
                if (self.cricdc !== $$vm.cricd.length) {
                    self.cricdc = $$vm.cricd.length;
                    check = true;
                }
                if (self.socdc !== $$vm.socd.length) {
                    self.socdc = $$vm.socd.length;
                    check = true;
                }
                if (self.tendc !== $$vm.tend.length) {
                    self.tendc = $$vm.tend.length;
                    check = true;
                }
                if (self.hordc !== $$vm.hord.length) {
                    self.hordc = $$vm.hord.length;
                    check = true;
                }
                if (self.gredc !== $$vm.gred.length) {
                    self.gredc = $$vm.gred.length;
                    check = true;
                }
            }
            if ($$vm.cn && check) {
                try {
                    $$vm.c.invoke("us", true, self.id1).then(
                        function (data) {
                            if (data !== undefined && data !== null && data.length > 0) {
                                data = $$vm.decompress(data);
                                //console.log(data);
                                $.each(data, function (ii, jj) {
                                    jj["A"] = jj["A"] === 1 ? true : false;
                                    jj["Ab"] = jj["Ab"] === 1 ? true : false;
                                    jj["Asc"] = jj["Asc"] === 1 ? true : false;
                                });
                                self.users = data;
                            }
                            $$vm.c.invoke("oc").then(
                                function (data) {
                                    if (data !== undefined && data !== null) {
                                        data = $$vm.decompress(data);
                                        self.maxcredit = data.Cr;
                                    }
                                    setTimeout(function () {
                                        self.update();
                                    }, 1000);
                                },
                                function (err) {
                                    setTimeout(function () {
                                        self.update();
                                    }, 1000);
                                }
                            );
                        },
                        function (err) {
                            setTimeout(function () {
                                self.update();
                            }, 1000);
                        }
                    );
                } catch (error) {
                    setTimeout(function () {
                        self.update();
                    }, 1000);
                }
            } else {
                setTimeout(function () {
                    self.update();
                }, 1000);
            }
        },
    }
}
</script>
<style></style>